import { combineReducers } from 'redux';
import tableConfigurationReducer from './tableConfigurations.reducer';
import interfaceConfigurationReducer from './interfaceConfiguration.reducer';

export default combineReducers({
  tableConfigurations: tableConfigurationReducer,
  interfaceConfiguration: interfaceConfigurationReducer,
});
